module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noneMatching":"No matching articles found","title":"Recent articles tagged with {0}"}}')
  delete Component.options._Ctor
}
